import {inject} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import {BriefModalComponent} from '../../pages/briefs/brief-modal/brief-modal.component';
import {MatDialog} from '@angular/material/dialog';
import {CanDeactivateFn} from '@angular/router';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | boolean;
}

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (
  component: CanComponentDeactivate
): Observable<boolean> | boolean => {
  const dialog = inject(MatDialog);
  if (component.canDeactivate()) {
    const dialogRef = dialog.open(BriefModalComponent, {
      height: 'auto',
      width: '340px',
      position: {top: '200px'},
      autoFocus: false
    });
    return dialogRef.afterClosed().pipe(map(result => (result ? result.event : false)));
  }
  return true;
};
